import React, { useState } from 'react';
import { CREATE_PROFILE } from '../../Utils/apis';
import useUserSetup from '../useUserSetup';
import useRedirect from '../Auth/useRedirect';

const useCreateProfile = (param) => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [isUserProfileCreated, setIsUserProfileCreated] = useState(false);
    const { redirect } = useRedirect();
    const fn = async (info) => {
    if (!loading) {
        try {
            setLoading(true);

            const profileData = {
                ...info,
                mobile: info.mobile,
            };

            const res = await fetch(CREATE_PROFILE, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(profileData),
            });

            if (res.ok) {
                setIsUserProfileCreated(true);
                param.onSucess();
                window.sessionStorage.removeItem('registrationFromData');
            } else {
                const err = await res.json();
                throw new Error(err.error);
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    }
};

    return [loading, error, isUserProfileCreated, fn];
}

export default useCreateProfile;